<template>
  <b-card>
    <b-row>
      <!-- User Info: Left col -->
      <b-col
        cols="21"
        xl="6"
        class="d-flex pl-1 justify-content-between flex-column"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="require(`@/assets/images/portrait/small/${credencial.genero === 'M' ? 'avatar-s-13' : 'avatar-s-7'}.jpg`)"
            text="Alumno"
            variant="light-primary"
            size="104px"
            rounded
          />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-2">
                {{ credencial.nombre }} {{ credencial.segundoNombre }} {{ credencial.apellidoPaterno }} {{ credencial.apellidoMaterno }}
              </h4>
              <span class="card-text"><a :href="`mailto:${credencial.email}`">{{ credencial.email }}</a> | <b>{{ credencial.matricula }}</b> </span>
            </div>
            <div class="d-flex flex-wrap">
              CURP: {{ credencial.curp }}
            </div>
          </div>
        </div>

        <!-- User Stats -->
        <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="FileTextIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0 text-center">
                <b>{{ credencial.rfc }}</b>
              </h5>
              <small>RFC</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar
              variant="light-success"
              rounded
            >
              <feather-icon
                icon="FileTextIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                {{ credencial.curp }}
              </h5>
              <small>CURP</small>
            </div>
          </div>
        </div>
      </b-col>

      <!-- Right Col: Table -->
      <b-col
        cols="12"
        xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="LinkedinIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Carrera</span>
            </th>
            <td class="pb-50">
              {{ profesion.carrera }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="BriefcaseIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Puesto</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ profesion.puesto }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Grado</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ profesion.grado }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="FlagIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Dpt.</span>
            </th>
            <td class="pb-50">
              {{ profesion.departamento }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon
                icon="PhoneIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Tel. </span>
            </th>
            <td>
              <a :href="`tel: ${credencial.telefono1}`">{{ credencial.telefono1 }} <span v-show="credencial.telefono2"> - {{ credencial.telefono2 }}</span></a>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BAvatar, BRow, BCol,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BCard, BRow, BCol, BAvatar,
  },
  props: {
    credencial: {
      type: Object,
      required: true,
    },
    profesion: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
}
</script>

<style>

</style>
